module.exports = __webpack_public_path__ + "static/img/materialsInfo4.cc7bce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo4.png
// module id = EX3N
// module chunks = 2